import { guideTips } from "@/mocks/home";

export default function GuideSection() {
  return (
    <section id="guide" className="w-full px-4 md:px-8 py-16 md:py-24 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
          <div className="lg:col-span-5">
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-900 text-xs md:text-sm">
              <i className="ri-bookmark-3-line" />
              防走失指南
            </span>
            <h2 className="mt-4 font-heading font-bold text-2xl md:text-4xl text-foreground-950">
              让「找不到地址」这件事彻底消失
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              地址会变，但习惯不会。只要提前做好下面几件小事，下次地址再变动时，你只需要回到本页就能立刻拿到最新入口，不必到处询问或翻找聊天记录。
            </p>

            <div className="mt-6 rounded-lg overflow-hidden border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Close-up%20editorial%20top-down%20photography%20of%20a%20notebook%20and%20pen%20with%20warm%20orange%20sticky%20notes%20on%20a%20cream%20desk%2C%20soft%20natural%20light%2C%20muted%20warm%20palette%2C%20minimal%20calm%20composition&width=900&height=700&seq=guide-91free-bookmark&orientation=landscape"
                alt="笔记本与便签记录多个备用入口地址的示意图"
                title="记录备用入口地址，做好防走失准备"
                className="w-full h-48 md:h-60 object-cover object-top"
              />
            </div>

            <div className="mt-6 rounded-lg border border-accent-200 bg-accent-50 p-4 md:p-5">
              <p className="flex items-start gap-3 text-sm text-accent-900 leading-relaxed">
                <i className="ri-lightbulb-flash-line text-lg shrink-0 mt-0.5" />
                小提示：把本页固定到浏览器书签栏，再在手机主屏添加一个快捷方式，桌面和手机各留一个入口，就基本不会再出现「一个入口失效、到处找不到」的情况。
              </p>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {guideTips.map((tip) => (
                <div
                  key={tip.id}
                  className="rounded-lg border border-background-200 bg-background-50 p-5 hover:border-accent-300 transition-colors"
                >
                  <span className="w-11 h-11 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center">
                    <i className={`${tip.icon} text-xl`} />
                  </span>
                  <h3 className="mt-4 font-heading font-bold text-base text-foreground-950">{tip.title}</h3>
                  <p className="mt-2 text-sm text-foreground-700 leading-relaxed">{tip.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}